import { render } from "./ticket.vue?vue&type=template&id=10e30894&scoped=true&ts=true"
import script from "./ticket.vue?vue&type=script&lang=ts"
export * from "./ticket.vue?vue&type=script&lang=ts"

import "./ticket.vue?vue&type=style&index=0&id=10e30894&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e30894"]])

export default __exports__